import Controller from "@ember/controller";
import discourseComputed from "discourse-common/utils/decorators";
export default Controller.extend(dt7948.p({
  selectedCategories(watching, watchingFirst, tracking, regular, muted) {
    return [].concat(watching, watchingFirst, tracking, regular, muted).filter(Boolean);
  }
}, [["method", "selectedCategories", [discourseComputed("model.watchingCategories.[]", "model.watchingFirstPostCategories.[]", "model.trackingCategories.[]", "model.regularCategories.[]", "model.mutedCategories.[]")]]]));